import React, { useState } from 'react';
import { XIcon, RocketIcon } from 'lucide-react';
export function AnnouncementBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="bg-gray-900 text-white px-4 py-3 relative flex items-center justify-center z-50" data-id="element-7" data-mp="jtk2zcg9cmk2">
      <div className="flex items-center space-x-2 text-sm md:text-base font-medium" data-id="element-8" data-mp="evin10e4p3ct">
        <RocketIcon className="h-4 w-4 text-red-500" data-id="element-9" data-mp="9vnuytima7q6" />
        <span data-id="element-10" data-mp="9xgzo39o6hvj">Free 60-Minute Strategy Session — Book Now</span>
      </div>
      <button onClick={() => setIsVisible(false)} className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white transition-colors" aria-label="Close announcement" data-id="element-11" data-mp="5t9ay637p1xb">
        <XIcon className="h-5 w-5" data-id="element-12" data-mp="3s33hmqafis34" />
      </button>
    </div>;
}